import {
    Component,
    OnInit,
    ViewChild,
    ElementRef,
    AfterViewInit,
} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap';
import {BsModalEventsEmitter} from 'src/app/modules/shared/events/bsModal.events';
import {DiaryService} from 'src/app/modules/shared/services/diary.service';
import {Constants} from '../../../../shared/config/constants.config';
import {DiaryRecipeViewModel} from '../../../../shared/viewModels/diaryRecipe.viewModel';
import {DiaryProductChangeViewModel} from '../../../../shared/viewModels/product.viewModel';
import {ViewRecipeComponent} from '../view-recipe/view-recipe.component';
import {MealsComponent} from '../../meals/meals.component';
import {AppLoadingEventsEmitter} from '../../../../shared/events/loading.events';
import {generateRandomString} from '../../../../shared/utilities/string.utilities';
import * as moment from 'moment';

@Component({
    selector: 'app-change-diary-recipe-product',
    templateUrl: './change-diary-recipe-product.component.html',
    styleUrls: ['./change-diary-recipe-product.component.scss'],
})
export class ChangeDiaryRecipeProductComponent implements OnInit, AfterViewInit {
    private readonly mobileWidth: number = 576;

    @ViewChild('wrapper') wrapper: ElementRef<HTMLElement>;

    viewRecipeComponent: ViewRecipeComponent;
    mealsComponent: MealsComponent;
    diaryRecipe: DiaryRecipeViewModel;
    diaryRecipeProductId: number;
    products: DiaryProductChangeViewModel[] = [];
    showNotFound = false;

    constructor(
        public readonly bsModalRef: BsModalRef,
        private readonly bsModalEventsEmitter: BsModalEventsEmitter,
        private readonly diaryService: DiaryService,
        readonly constants: Constants,
        private readonly appLoadingEventsEmitter: AppLoadingEventsEmitter,
    ) {
    }

    ngOnInit() {
        this.init();
    }

    ngAfterViewInit() {
        if (window.innerWidth <= this.mobileWidth) {
            this.toFullscreen();
        }
    }

    round(number: number): number {
        return Math.round(number);
    }

    onAdd() {
    }


    private init() {
        this.appLoadingEventsEmitter.broadcastAppIsLoading(true);

        const interval = setInterval(() => {
            if (this.diaryRecipe) {
                clearInterval(interval);

                this.diaryService.getSuggestionProductsToChange(this.diaryRecipe.id, this.diaryRecipeProductId).subscribe(data => {
                    this.products = data['possible_products'];

                    if (this.products.length <= 0) {
                        this.showNotFound = true;
                    }

                    this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
                });
            }
        });
    }

    private toFullscreen() {
        const modalDialog = this.wrapper.nativeElement.parentElement.parentElement.parentElement;
        const modalContent = this.wrapper.nativeElement.parentElement.parentElement;
        const modal = this.wrapper.nativeElement.parentElement;

        modalDialog.style.borderRadius = '0';
        modalDialog.style.display = 'flex';
        modalDialog.style.margin = '0';
        modalDialog.style.padding = '0';
        modalDialog.style.width = '100%';
        modalDialog.style.maxWidth = 'unset';
        modalDialog.style.minHeight = '100%';
        modalDialog.style.height = '100%';
        modalContent.style.borderRadius = '0';
        modal.style.display = 'block';
        modal.style.height = '100%';
    }

    changeProduct(product: DiaryProductChangeViewModel) {
        this.appLoadingEventsEmitter.broadcastAppIsLoading(true);

        this.clearShoppingList().subscribe(() => {
        });

        this.diaryService.changeDiaryRecipeProduct(this.diaryRecipe.id, this.diaryRecipeProductId, product.id, product.calculations.weight, product.calculations.qty)
            .subscribe(data => {
                this.viewRecipeComponent.diaryRecipe = data['diary_recipe'];
                this.viewRecipeComponent.changeDetectorRef.detectChanges();

                this.viewRecipeComponent.showMacros = false;
                this.viewRecipeComponent.changeDetectorRef.detectChanges();

                this.viewRecipeComponent.showMacros = true;
                this.viewRecipeComponent.changeDetectorRef.detectChanges();

                this.viewRecipeComponent.init();
                this.viewRecipeComponent.changeDetectorRef.detectChanges();

                this.mealsComponent.init().subscribe(() => {

                });

                this.bsModalRef.hide();
            });
    }

    private clearShoppingList() {
        const date = new Date();
        const monday = new Date(date.setDate((date.getDate() - date.getDay() + (date.getDay() === 0 ? -6 : 1))));
        const sunday = new Date(date.setDate(date.getDate() - date.getDay() + ((date.getDay() === 0 ? -6 : 1)) + 6));

        return this.diaryService.clearShoppingItems(moment(monday).format('YYYY-MM-DD'), moment(sunday).format('YYYY-MM-DD'));
    }

    rand() {
        return generateRandomString(25);
    }
}
